




import Vue from 'vue'
import Component from 'vue-class-component'
import moment from '@/plugins/moment'
@Component
export default class Clock extends Vue {
  time = moment()
  mounted() {
    setInterval(() => {
      this.time = moment()
    }, 1000)
  }
}
